import { render, staticRenderFns } from "./OrgModal.vue?vue&type=template&id=2edcd66e&"
import script from "./OrgModal.vue?vue&type=script&lang=js&"
export * from "./OrgModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports